var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vl-form',_vm._b({on:{"click":function($event){$event.stopPropagation();return _vm.$_clickAction($event)}}},'vl-form',_vm.$_attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }